"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CF_URL = "https://d3uwib8iif8w1p.cloudfront.net/";
var CDN_URL = "https://cdn.quixel.com/";
var CF_MS_URL = CF_URL + "megascans/";
var CF_QX_URL = CF_URL + "quixel/";
var CDN_QX_URL = CDN_URL + "quixel/";

var cf_ms = exports.cf_ms = function cf_ms(path) {
  return __CLIENT__ && CF_MS_URL + path || '';
};
var cf_thumbs = exports.cf_thumbs = function cf_thumbs(path) {
  return CDN_QX_URL + 'thumbs/' + path;
};
var cf_icons = exports.cf_icons = function cf_icons(path) {
  return __CLIENT__ && CF_QX_URL + 'icons/' + path || '';
};
var cf_testimonials = exports.cf_testimonials = function cf_testimonials(path) {
  return __CLIENT__ && CF_QX_URL + 'testimonials/' + path || '';
};
var cf_qx_page = exports.cf_qx_page = function cf_qx_page(page, path) {
  return __CLIENT__ && CF_QX_URL + page + '/' + path || '';
};

var companyLogos = ['1-square-enix.png', '2-ubisoft.png', '3-warner-brothers.png', '4-capcom.png', '5-technicolor.png', 'sega.png', '7-ea.png', '8-mpc.png', '9-dneg.png', '2k.png', 'unity-icon-only.png', 'cd-project-red.png', '13-amazon.png', 'unreal.png', '15-blur.png', '16-naughty-dog.png'];

var footerLogos = ['16-naughty-dog.png', '8-mpc.png', '4-capcom.png', '5-dice.png', 'unreal.png', 'sega.png', '3-warner-brothers.png', '8-eidos.png', '9-crystal-dynamics.png', '12-unity.png', '11-bungie.png', '12-gnomon.png'];

var CF_COMPANY_LOGOS_URL = CF_QX_URL + "company_logos_2/";

var fullCompanyLogos = exports.fullCompanyLogos = __CLIENT__ && companyLogos.map(function (c) {
  return CF_COMPANY_LOGOS_URL + c;
}) || [];
var footerCompanyLogos = exports.footerCompanyLogos = __CLIENT__ && footerLogos.map(function (c) {
  return CF_COMPANY_LOGOS_URL + c;
}) || [];

var limitedCompanyLogos = exports.limitedCompanyLogos = function limitedCompanyLogos(limit) {
  return __CLIENT__ && companyLogos.slice(0, limit).map(function (c) {
    return CF_COMPANY_LOGOS_URL + c;
  }) || [];
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/cloudFront.js
// module id = 169
// module chunks = 0